import { NavLink, Outlet, Navigate } from 'react-router-dom';

// Reports shell — tabs across the top, active tab renders via <Outlet />.
// Currently just "Systems"; more tabs land as sibling routes under /admin/reports.
const TABS = [
  { path: 'systems', label: 'Systems' },
];

export default function AdminReports() {
  return (
    <div>
      <h1 style={{ color: 'var(--mi-navy)', marginTop: 0 }}>Reports</h1>

      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid #ddd', marginBottom: 16 }}>
        {TABS.map((t) => (
          <NavLink
            key={t.path}
            to={t.path}
            style={({ isActive }) => ({
              padding: '10px 16px',
              textDecoration: 'none',
              borderBottom: isActive ? '2px solid var(--mi-navy)' : '2px solid transparent',
              marginBottom: -1,
              color: isActive ? 'var(--mi-navy)' : '#888',
              fontWeight: isActive ? 600 : 400,
              fontSize: 14,
            })}
          >
            {t.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}

// Default child when the user hits /admin/reports.
export function AdminReportsIndex() {
  return <Navigate to="systems" replace />;
}
